import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    ComponentFactoryResolver,
    EventEmitter,
    Input,
    OnInit,
    Output,
    QueryList,
    ViewChildren,
    ViewContainerRef
} from '@angular/core';
import {IFormItemsControls} from '../../../interface/form-structure';
import {NoosFormTypeService} from '../../../class/NoosFormTypeService';
import {FormItemComponentInterface} from '../../../interface/component';

@Component({
    selector: 'noos-form-pad-column',
    templateUrl: './form-pad-column.component.html',
    styleUrls: ['./form-pad-column.component.scss']
})
export class FormPadColumnComponent implements OnInit, AfterViewInit {

    @ViewChildren('dynamic', {read: ViewContainerRef}) public widgetTargets: QueryList<ViewContainerRef>;

    @Input()
    controls: IFormItemsControls[];

    @Input()
    datasetId: any;

    @Input()
    isFilter: any;

    @Input()
    formId = 0;

    @Output()
    keyOnEnter = new EventEmitter<any>();

    constructor(
        private componentFactoryResolver: ComponentFactoryResolver,
        private noosFormTypeFactory: NoosFormTypeService,
        private cd: ChangeDetectorRef
    ) {
    }

    ngOnInit() {
    }

    ngAfterViewInit(): void {
        this.widgetTargets.changes.subscribe(() => {
            this.compileForm();
        });
        this.compileForm();
    }

    compileForm() {

        for (let i = 0; i < this.widgetTargets.toArray().length; i++) {
            const conf = this.controls[i];
            if (conf) {
                const target = this.widgetTargets.toArray()[i];
                target.clear();
                const component = this.noosFormTypeFactory.getPostTypeFromString(conf.type);
                if (component === null) {
                    console.log('component null:', conf);
                    return;
                }
                const componentFactory = this.componentFactoryResolver.resolveComponentFactory(component);
                const componentRef = target.createComponent(componentFactory);
                (componentRef.instance as FormItemComponentInterface).prop = conf;
                (componentRef.instance as FormItemComponentInterface).datasetId = this.datasetId;
                (componentRef.instance as FormItemComponentInterface).formId = this.formId;
                (componentRef.instance as FormItemComponentInterface).isFilter = this.isFilter;
                (componentRef.instance as FormItemComponentInterface).keyOnEnter.subscribe(ret => {
                    this.keyOnEnter.emit();
                });
                componentRef.changeDetectorRef.detectChanges();
                this.cd.detectChanges();


            }
        }

    }

}
